// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/header.scss
// module id = 411
// module chunks = 2